const PRIME_ICONS = {
  EXCLAMATION_TRIANGLE: 'pi pi-exclamation-triangle',
  CHECK_CIRCLE: 'pi pi-check-circle',
  INFO_CIRCLE: 'pi pi-info-circle'
}

export class CONSTANTS {
  public static PRIME_ICONS = PRIME_ICONS
}
